import { render, staticRenderFns } from "./DurationConfig.vue?vue&type=template&id=ebf59be0&scoped=true&"
import script from "./DurationConfig.vue?vue&type=script&lang=js&"
export * from "./DurationConfig.vue?vue&type=script&lang=js&"
import style0 from "./DurationConfig.vue?vue&type=style&index=0&id=ebf59be0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebf59be0",
  null
  
)

export default component.exports